import React, { useEffect, useState } from 'react';
import { ButtonWithText } from '../../../../atoms/Buttons/ButtonWithText';
import { AccountDetails as AccountDetailsInfos } from '../../../../organisms/forms/AccountDetails';
import { ApolloError, useQuery } from '@apollo/client';
import { QueryUserAccountQuery } from '../../../../../graphql/generated/graphql';
import { QUERY_USER_ACCOUNT } from '../../../../../graphql/query/user/queryUserAccount';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../../store/reducers';
import { getUserStateFromQueryAccount } from '../../../../../helpers/transformApiResponse/user';
import { LoadingLayout } from '../../../../molecules/Loaders/LoadingLayout';
import { ErrorContainer } from '../../../../organisms/Error/ErrorContainer';
import { displayErrEleveInfos } from '../../../../../helpers/user/testEleve/testInfos';
import useStyle from './account.style';
import { FeatureContainer } from '../../../../molecules/Containers/FeatureContainer';

interface AccountDetailsProps {
  previous: () => void;
  next: () => void;
}
export const AccountDetails = ({ previous, next }: AccountDetailsProps) => {
  const classes = useStyle();
  const user = useSelector((state: AppState) => state.user);
  const [errorsInfo, setErrorsInfo] = useState(displayErrEleveInfos(user));
  const { data, loading, error } = useQuery<QueryUserAccountQuery>(
    QUERY_USER_ACCOUNT,
    {
      variables: { id: user.id }
    }
  );
  useEffect(() => {
    setErrorsInfo(displayErrEleveInfos(user));
  }, [user]);

  if (loading) return <LoadingLayout />;
  if (error) return <ErrorContainer detailErr={new ApolloError(error)} />;
  return (
    <div className={classes.root}>
      <div className={classes.headintro}>
        <p>Complète tes informations personnelles</p>
      </div>
      <FeatureContainer>
        <p>
          Nous avons besoin de ton adresse e-mail et de ton numéro de téléphone.
        </p>
        <p>
          Au passage, n'hésites pas à rectifier ton nom et ton prénom.{' '}
          <span role="img" aria-label="check">
            ✅
          </span>
        </p>
      </FeatureContainer>
      <div className={classes.gap}>
        <AccountDetailsInfos
          user={getUserStateFromQueryAccount(data.getUserAccount)}
          editablePassword={false}
          visibleTitle={false}
        />
        <div className={classes.buttons}>
          <ButtonWithText content="Précédent" onClick={previous} />
          <ButtonWithText
            content="Suivant"
            onClick={next}
            disabled={errorsInfo.updatedMail || errorsInfo.tel}
          />
        </div>
      </div>
    </div>
  );
};
